import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@univacity/angular/datas';
import {
  AngularUiModule,
  ColorSchemeService,
  DestroyAbleComponent,
  Menu,
} from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { takeUntil } from 'rxjs';
import { MessagesFacade } from '../../+state/messages/messages.facade';
import { MessageThreadListComponent } from '../../dashboard/message/message-thread-list/message-thread-list.component';
import { mainMenu } from '../main-menu';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';
import { SearchDrawerComponent } from '../search-drawer/search-drawer.component';
import { UserNavComponent } from '../user-nav/user-nav.component';

@Component({
  selector: 'un-header',
  imports: [
    AsyncPipe,
    RouterModule,
    NzLayoutModule,
    // NzIconModule,
    AngularUiModule,
    UserNavComponent,
    NzBadgeModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HeaderComponent extends DestroyAbleComponent implements OnInit {
  isCollapsed = false;
  layout = 'light';
  fullWidth?: boolean;

  mainMenu: Menu[] = mainMenu;
  RoutePath = RoutePath;

  constructor(
    private colorScheme: ColorSchemeService,
    public auth: AuthService,
    private cdr: ChangeDetectorRef,
    private drawer: NzDrawerService,
    public messageFacade: MessagesFacade
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupLayout();
    if (this.auth.isLoggedIn) {
      this.messageFacade.fetchAllUnread();
    }
  }

  setupLayout() {
    this.colorScheme.init();
    this.layout = this.colorScheme.currentActive();
    this.colorScheme.theme$.pipe(takeUntil(this.dead$)).subscribe((theme) => {
      this.layout = theme;
      this.cdr.detectChanges();
    });
  }

  openSearchDrawer() {
    this.drawer.create({
      nzTitle: $localize``,
      nzContent: SearchDrawerComponent,
      nzPlacement: 'top',
      nzMaskClosable: true,
      nzWidth: '100%',
    });
  }

  openMessagesPreview() {
    this.drawer.create({
      nzContent: MessageThreadListComponent,
      nzTitle: $localize`Messages`,
      nzContentParams: {
        hideProfile: true,
      },
      nzCloseOnNavigation: true,
    });
  }
  openMobileMenu() {
    this.drawer.create({
      nzContent: MobileMenuComponent,
      nzClosable: false,
      nzCloseOnNavigation: true,
      nzWidth: '100vw',
      nzBodyStyle: {
        padding: '0',
      },
    });
  }
}
